import styled from 'styled-components/macro';

export const ParseErrorsModalTitle = styled.div`
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 15px;
    width: 1000px;
`;
